<template>
  <div class="slide-container" ref="slideContainer">
    <div class="swiper-container" ref="swiperContainer">
      <div class="swiper-wrapper">
        <div
          v-if="!dataList || dataList.length === 0"
          class="swiper-slide"
        >
          <div class="item-grid">
            <div
              class="grid-item fixed-last-item"
              @click="handleItemClick(fixedItem)"
            >
              <img :src="fixedItem.icon" class="grid-img" alt="" />
              <span class="grid-text">{{ fixedItem.name }}</span>
              <img :src="badgeIcon" class="badge-icon" />
            </div>
          </div>
        </div>

        <div
          v-for="(item, index) in dataList"
          :key="index"
          class="swiper-slide"
        >
          <div class="item-grid">
            <div
              class="grid-item"
              v-for="(child, idx) in item.children.slice(0, 7)"
              :key="idx"
              @click="handleItemClick(child)"
            >
              <img :src="getIconByName(child.name)" class="grid-img" alt="" />
              <span class="grid-text">{{ child.name }}</span>
            </div>
            <div
              class="grid-item fixed-last-item"
              @click="handleItemClick(fixedItem)"
            >
              <img :src="fixedItem.icon" class="grid-img" alt="" />
              <span class="grid-text">{{ fixedItem.name }}</span>
              <img :src="badgeIcon" class="badge-icon" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="slide-indicator" v-if="dataList && dataList.length > 1">
      <div class="indicator-track" :style="{ width: trackWidth + 'px' }">
        <div
          class="indicator-slider"
          :style="{ left: sliderPosition + '%' }"
        ></div>
      </div>
    </div>
    <div v-else class="indicator-empty"></div>
  </div>
</template>

<script>
import Swiper from 'swiper/js/swiper.js'
import 'swiper/css/swiper.css'
import askIcon from '@/assets/image/ask_question.png'
import badgeIcon from '@/assets/image/badge.png'
import Byd from '@/utils/Byd.js'
import { track } from '@/utils/tracking.js'

// 图标名称映射
const iconMap = {
  '订单中心': require('@/assets/image/订单中心.png'),
  '保养查询': require('@/assets/image/保养查询.png'),
  '使用手册': require('@/assets/image/使用手册.png'),
  '服务进度': require('@/assets/image/服务进度.png'),
  '服务记录': require('@/assets/image/服务记录.png'),
  '事故服务': require('@/assets/image/事故服务.png'),
  '三包手册': require('@/assets/image/三包手册.png'),
  '充电服务': require('@/assets/image/充电服务.png'),
  '汽车知识': require('@/assets/image/汽车知识.png'),
  '权益查询': require('@/assets/image/权益查询.png'),
  '权益中心': require('@/assets/image/权益查询.png'),
  '服务预约': require('@/assets/image/服务预约.png'),
  '流量查询': require('@/assets/image/流量查询.png'),
  '我的流量': require('@/assets/image/流量查询.png'),
  '积分中心': require('@/assets/image/积分中心.png'),
  '门店查询': require('@/assets/image/门店查询.png'),
  '道路救援': require('@/assets/image/道路救援.png'),
  '取送车': require('@/assets/image/取送车.png'),
  '泊车服务': require('@/assets/image/泊车服务.png'),
  '家桩服务': require('@/assets/image/家桩服务.png'),
  '精诚服务管家': require('@/assets/image/精诚服务管家.png'),
  '技师直问': require('@/assets/image/技师直问.png'),
  'AI技师直问': require('@/assets/image/技师直问.png'),
}

export default {
  name: 'Slide',
  props: {
    dataList: {
      type: Array,
      required: true,
      default: () => [],
    },
    fixedItem: {
      type: Object,
      default: () => ({
        icon: askIcon,
        name: '技师直问',
        id:'fe_4'
      }),
    },
    appid: {
      type: String,
      default: '',
    },
    servicePageData: {
      type: Object,
      default: null,
    },
    userGuideFeature: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      badgeIcon,
      currentIndex: 0,
      sliderPosition: 0,
      trackWidth: 24,
      mySwiper: null,
    }
  },
  methods: {
    getIconByName(name) {
      return iconMap[name] || null
    },
    handleServicePagePath(featureName) {
      if (!this.servicePageData) {
        return null
      }

      const modules = this.servicePageData.modules || []
      let featureObj = null
      modules.some((module) => {
        const features = module.features || []
        return features.some((feature) => {
          if (feature.feature_name === featureName) {
            featureObj = feature
            return true
          }
          return false
        })
      })
      return featureObj
    },
    handleItemClick(item) {
      // b: 推荐服务：统计用户点击推荐服务模块内服务卡片的数量
			track({
				param: {
					eventCode: 'recommend_service_click',
					pageCode:'self_service_page'
				},
			})
      // 自助用户点击次数
      track({
				param: {
					cardId:item.id
				},
			})
      if (item.name === '订单中心') {
        Byd.navigateToNative(
          {
            name: 'toMyOrder',
          },
          {
            success: (res) => {
              console.log('调用成功:', res?.data)
            },
            fail: (err) => {
              console.error('调用失败:', err?.error)
            },
          },
        )
        return
      }

      if (item.name === '使用手册') {
        if (!this.userGuideFeature) {
          this.$store.commit('showMessage', {
            message: '该功能暂未开放',
            type: 'error',
          })
          return
        }
        Byd.navigateToNative({
          name: 'navigateToService',
          extend: this.userGuideFeature,
        })
        return
      }

      if (item.name === '权益查询' || item.name === '权益中心') {
        Byd.navigateToNative(
          {
            name: 'toRightCenter',
          },
          {
            success: (res) => {
              console.log('调用成功:', res?.data)
            },
            fail: (err) => {
              console.error('调用失败:', err?.error)
            },
          },
        )
        return
      }

      if (item.name === '流量查询' || item.name === '我的流量') {
        Byd.navigateToNative(
          {
            name: 'toMyTraffic',
          },
          {
            success: (res) => {
              console.log('调用成功:', res?.data)
            },
            fail: (err) => {
              console.error('调用失败:', err?.error)
            },
          },
        )
        return
      }

      if (item.name === '积分中心') {
        Byd.navigateToNative(
          {
            name: 'toPointsCenter',
          },
          {
            success: (res) => {
              console.log('调用成功:', res?.data)
            },
            fail: (err) => {
              console.error('调用失败:', err?.error)
            },
          },
        )
        return
      }

      if (item.name === '苏卡ETC' || item.name === '苏通ETC') {
        Byd.navigateToNative(
          {
            name: 'toEtcOnlineService',
          },
          {
            success: (res) => {
              console.log('调用成功:', res?.data)
            },
            fail: (err) => {
              console.error('调用失败:', err?.error)
            },
          },
        )
        return
      }

      if (item.name === '技师直问') {
        const feature = this.handleServicePagePath('AI技师直问')
        if (feature) {
          Byd.navigateToNative({
            name: 'navigateToService',
            extend: feature,
          })
          return
        }
      }

      const feature = this.handleServicePagePath(item.name)
      if (feature) {
        Byd.navigateToNative({
          name: 'navigateToService',
          extend: feature,
        })
        return
      }

      this.$store.commit('showMessage', {
        message: '该功能暂未开放',
        type: 'error',
      })
    },
    handleSlideChange() {
      if (this.mySwiper) {
        this.currentIndex = this.mySwiper.realIndex || this.mySwiper.activeIndex
        this.updateSliderPosition()
      }
    },
    calculateTrackWidth() {
      const totalPages = this.dataList.length
      if (totalPages <= 1) {
        this.trackWidth = 24
      } else {
        const sliderWidth = 11
        this.trackWidth = totalPages * sliderWidth
      }
    },
    updateSliderPosition() {
      const totalPages = this.dataList.length
      if (totalPages <= 1) {
        this.sliderPosition = 50
      } else {
        const sliderWidth = 11
        const sliderHalf = sliderWidth / 2
        this.trackWidth = totalPages * sliderWidth
        const minPosition = ((sliderHalf + 1) / this.trackWidth) * 100
        const maxPosition = ((this.trackWidth - sliderHalf - 1) / this.trackWidth) * 100
        const rawPosition = ((this.currentIndex * sliderWidth + sliderHalf) / this.trackWidth) * 100
        this.sliderPosition = Math.max(minPosition, Math.min(maxPosition, rawPosition))
      }
    },
    initSwiper() {
      if (this.$refs.swiperContainer) {
        this.mySwiper = new Swiper(this.$refs.swiperContainer, {
          direction: 'horizontal',
          loop: false,
          touchRatio: 1,
          simulateTouch: true,
          touchAngle: 45,
          longSwipesRatio: 0.5,
          shortSwipes: true,
          followFinger: true,
          preventClicks: true,
          preventClicksPropagation: true,
          on: {
            slideChange: this.handleSlideChange,
          },
        })
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.dataList.length > 1) {
        this.calculateTrackWidth()
        this.updateSliderPosition()

        // 初始化 Swiper
        this.initSwiper()
      }
    })
  },
  beforeUnmount() {
    // 销毁 Swiper 实例
    if (this.mySwiper) {
      this.mySwiper.destroy()
      this.mySwiper = null
    }
  },
  watch: {
    dataList: {
      handler() {
        this.$nextTick(() => {
          this.calculateTrackWidth()
          this.updateSliderPosition()
        })
      },
      deep: true,
    },
  },
}
</script>

<style scoped lang="less">
*{
  box-sizing: border-box;

}
.slide-container {
  width: 100%;
  overflow: hidden;
  position: relative;
  touch-action: pan-y;
  user-select: none;
  -webkit-user-select: none;
  -webkit-overflow-scrolling: touch;
  cursor: -webkit-grab;
  cursor: grab;
  -webkit-tap-highlight-color: transparent;
  .px2rem(padding-top, 16);
}

.slide-container:active {
  cursor: -webkit-grabbing;
  cursor: grabbing;
}

.slide-swiper {
  width: 100%;
  height: auto;
}

.swiper-wrapper {
  display: flex;
}

.swiper-container {
  width: 100%;
  height: auto;
  overflow: visible;
}

.swiper-slide {
  width: 100%;
  flex-shrink: 0;
  box-sizing: border-box;
  overflow: visible;
}

.item-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  .px2rem(column-gap, 2);
  .px2rem(row-gap, 10);
}

.grid-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.grid-img {
  .px2rem(width, 24);
  .px2rem(height, 24);
  .px2rem(margin-bottom, 8);
  object-fit: cover;
  // border-radius: 6px;
}

.grid-text {
  .px2rem(font-size, 12);
  .px2rem(line-height, 16);
  color: #5C606A;
  text-align: center;
}

.slide-indicator {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  .px2rem(padding-top, 12);
}

.indicator-empty{
  .px2rem(height, 17);
}

.indicator-track {
  .px2rem(width, 24);
  .px2rem(height, 5);
  .px2rem(padding, 1);
  background: #C2C8D3;
  .px2rem(border-radius, 2.5);
  position: relative;
  overflow: hidden;
}

.indicator-slider {
  position: absolute;
  top: 50%;
  .px2rem(width, 11);
  .px2rem(height, 3);
  background: rgba(255, 255, 255, 1);
  .px2rem(border-radius, 1.5);
  transition: left 0.3s ease;
  transform: translate(-50%, -50%);
}

.badge-icon {
  .px2rem(width, 37);
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(0, -4px);
}
</style>
